import { Component, Prop } from 'vue-property-decorator'
import { Table as TableInterface, Seat, Player } from '@interfaces/tables'
import { mixins } from 'vue-class-component'
import MixinGame from '@mixins/game'
import auth from '@/services/auth'

@Component
export default class Table extends mixins(MixinGame) {
  @Prop() public table: TableInterface

  get tableReady (): boolean {
    return this.table.allSeatsTaken && !this.tableOccupied
  }

  get tableOccupied (): boolean {
    return this.table.status === 'occupied'
  }

  get yourTable (): boolean {
    return this.table.seats.find((seat: any) => seat.player.key === auth.userKey) !== undefined
  }

  get seatA (): Seat {
    return this.table.seats[0]
  }

  get seatB (): Seat {
    return this.table.seats[1]
  }

  get seatC (): Seat {
    return this.table.seats[2]
  }

  get seatD (): Seat {
    return this.table.seats[3]
  }

  public takeSeat (seat: Seat) {
    this.$feathers.service('/api/seats').patch(seat.id, {})
  }

  public startGame () {
    this.$feathers.service('api/tables').patch(this.table.id, {
      start: true,
    })
  }
}
